import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";
import Home from "./pages/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import Events from "./pages/Events";
import { PageWrapper } from "./styles/Layouts";
import NavBar from "./components/NavBar";
import { MainImage } from "./styles/Images";

const NewApp = () => {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <PageWrapper>
          <MainImage />
          <NavBar />
          <Routes>
            <Route index element={<Home />} />
            <Route path="events" element={<Events />} />
            <Route path="events/success" element={<Success />} />
            <Route path="events/cancel" element={<Cancel />} />
          </Routes>
        </PageWrapper>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default NewApp;
